import React, { useState } from "react";
import "./Loginpage.css"; // reuse same css
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Registerpage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    fullname: "",
    email: "",
    phone: "",
    country: "",
    password: "",
    confirmPassword: ""
  });

  const handleRegister = (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      toast.error("Passwords do not match ❌");
      return;
    }
    localStorage.setItem("user", JSON.stringify(form));
    toast.success("Registered Successfully ✅");
    navigate("/");
  };

  return (
    <div className="login-container">
      <ToastContainer position="top-right" autoClose={2000} />
      <div className="login-card">
        <h2 className="login-title">Create Account</h2>
        <p className="login-subtitle">Register to continue</p>
        <form onSubmit={handleRegister}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Full Name"
              required
              onChange={(e) =>
                setForm({ ...form, fullname: e.target.value })
              }
            />
          </div>
          <div className="input-group">
            <input
              type="email"
              placeholder="Email Address"
              required
              onChange={(e) =>
                setForm({ ...form, email: e.target.value })
              }
            />
          </div>
          <div className="input-group">
            <input
              type="tel"
              placeholder="Phone Number"
              required
              onChange={(e) =>
                setForm({ ...form, phone: e.target.value })
              }
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              f placeholder="Password"
              required
              onChange={(e) =>
                setForm({ ...form, password: e.target.value })
              }
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              placeholder="Confirm Password"
              required
              onChange={(e) =>
                setForm({ ...form, confirmPassword: e.target.value })
              }
            />
          </div>
          <button className="login-btn">Register</button>
          <p className="bottom-text">
            Already have an account?{" "}
            <span onClick={() => navigate("/")}>Login</span>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Registerpage;